import Vue from "vue";
import Router from "vue-router";
import Register from "@/components/page/register";
import Login from "@/components/page/login";
import Index from "@/components/page/index";
import Category from "@/components/page/category";
import Promotion from "@/components/page/promotion";
import ModuleGoods from "@/components/page/moduleGoods";

import Goods832 from "@/components/page/goods832";
import Cooperation from "@/components/page/cooperation";
import HelpPoor from "@/components/page/helpPoor";
import CategoryGoods from "@/components/page/categoryGoods";
import ShopCar from "@/components/page/shopCar";
import OrderPay from "@/components/page/orderPay";
import GoodsInfo from "@/components/page/goodsInfo";
import ProofPay from "@/components/page/proofPay";
import BalancePay from "@/components/page/balancePay";
import PaySuccess from "@/components/page/paySuccess";
import ResetPassword from "@/components/page/resetPassword";
import OrderDetails from "@/components/page/orderDetails";

import Personal from "@/components/page/personal/home";
import MyOrder from "@/components/page/personal/myOrder";
import RateOrder from "@/components/page/personal/rateOrder";
import MyRate from "@/components/page/personal/myRate";
import MyCollection from "@/components/page/personal/myCollection";
import MyAddress from "@/components/page/personal/myAddress";
import MyInvoice from "@/components/page/personal/myInvoice";
import InvoiceDetails from "@/components/page/personal/invoiceDetails";
import DataSummary from "@/components/page/personal/dataSummary";

import TransactionContract from "@/components/page/personal/transactionContract";
import PlatformAuthorization from "@/components/page/personal/platformAuthorization";



import CompanyInfo from "@/components/page/personal/companyInfo";
import EditPassword from "@/components/page/personal/editPassword";
import EditPhone from "@/components/page/personal/editPhone";
import SubAccount from "@/components/page/personal/subAccount";


import InfoCenter from "@/components/page/infoCenter";
import InfoDetails from "@/components/page/infoDetails";
import RetrievePassword from "@/components/page/retrievePassword"
import ChangePassword from "@/components/page/changePassword";
import BindPhone from "@/components/page/bindPhone";



Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: "/",
      name: "login",
      component: Login,
      meta: { head: true, isLogin: true }
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: { head: true, }
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { head: true, isLogin: true }
    },
    {
      path: "/index",
      name: "Index",
      component: Index,
      meta: { isShow: false, needLogin: true }
    },
    {
      path: "/category",
      name: "商品分类",
      component: Category,
      meta: { needLogin: true, keepAlive: true }
    },
    {
      path: "/promotion",
      name: "商品分类",
      component: Promotion,
      meta: { isShow: false, needLogin: true, keepAlive: true }
    },
    {
      path: "/moduleGoods",
      name: "商品分类",
      component: ModuleGoods,
      meta: { isShow: false, needLogin: true, keepAlive: true }
    },
    {
      path: "/goods832",
      name: "商品分类",
      component: Goods832,
      meta: { isShow: false, needLogin: true, keepAlive: true }
    },
    {
      path: "/cooperation",
      name: "商品分类",
      component: Cooperation,
      meta: { isShow: false, needLogin: true, keepAlive: true }
    },
    {
      path: "/helpPoor",
      name: "商品分类",
      component: HelpPoor,
      meta: { isShow: false, needLogin: true, keepAlive: true }
    },
    {
      path: "/categoryGoods",
      name: "商品分类 ",
      component: CategoryGoods,
      meta: { needLogin: true, keepAlive: true, footColor: '#f6f6f6' }
    },
    {
      path: "/shopCar",
      name: "购物车",
      component: ShopCar,
      meta: { needLogin: true }
    },
    {
      path: "/orderPay",
      name: "订单支付页",
      component: OrderPay,
      meta: { needLogin: true }
    },
    {
      path: "/goodsInfo",
      name: "商品详情",
      component: GoodsInfo,
      meta: { needLogin: true }
    },
    {
      path: "/proofPay",
      name: "proofPay",
      component: ProofPay,
      meta: { needLogin: true }
    },
    {
      path: "/balancePay",
      name: "balancePay",
      component: BalancePay,
      meta: { needLogin: true }
    },
    {
      path: "/paySuccess",
      name: "付款成功",
      component: PaySuccess,
      meta: { needLogin: true }
    },
    {
      path: "/resetPassword",
      name: "resetPassword",
      component: ResetPassword,
      meta: { head: true, foot: true, needLogin: true }
    },
    {
      path: "/orderDetails",
      name: "订单详情",
      component: OrderDetails,
      meta: { needLogin: true }
    },
    {
      path: "/personal",
      name: "personal",
      component: Personal,
      redirect: "myOrder",
      children: [
        {
          path: "/myOrder",
          name: "我的订单",
          component: MyOrder,
          meta: { needLogin: true }
        },
        {
          path: "/myCollection",
          name: "我的收藏",
          component: MyCollection,
          meta: { needLogin: true }
        },
        {
          path: "/myAddress",
          name: "我的地址",
          component: MyAddress,
          meta: { needLogin: true }
        },
        {
          path: "/myInvoice",
          name: "我的发票",
          component: MyInvoice,
          meta: { needLogin: true }
        },
        {
          path: "/invoiceDetails",
          name: "发票详情",
          component: InvoiceDetails,
          meta: { needLogin: true }
        },
        {
          path: "/dataSummary",
          name: "订单数据汇总",
          component: DataSummary,
          meta: { needLogin: true }
        },

        {
          path: "/companyInfo",
          name: "企业资质",
          component: CompanyInfo,
          meta: { needLogin: true }
        },
        {
          path: "/subAccount",
          name: "企业资质",
          component: SubAccount,
          meta: { needLogin: true }
        },

        {
          path: "/editPassword",
          name: "editPassword",
          component: EditPassword,
          meta: { needLogin: true }
        },
        {
          path: "/editPhone",
          name: "editPhone",
          component: EditPhone,
          meta: { needLogin: true }
        },
        {
          path: "/transactionContract",
          name: "transactionContract",
          component: TransactionContract,
          meta: { needLogin: true }
        },
        {
          path: "/platformAuthorization",
          name: "platformAuthorization",
          component: PlatformAuthorization,
          meta: { needLogin: true }
        },
        {
          path: "/myRate",
          name: "我的评价",
          component: MyRate,
          meta: { needLogin: true }
        },
        {
          path: "/rateOrder",
          name: "评价订单",
          component: RateOrder,
          meta: { needLogin: true }
        },

      ]
    },
    {
      path: "/infoCenter",
      name: "infoCenter",
      component: InfoCenter,
      meta: { head: true, needLogin: false }
    },
    {
      path: "/infoDetails",
      name: "infoDetails",
      component: InfoDetails,
      meta: { head: true, needLogin: false }
    },

    {
      path: "/retrievePassword",
      name: "retrievePassword",
      component: RetrievePassword,
      meta: { head: true }
    },
    {
      path: "/changePassword",
      name: "changePassword",
      component: ChangePassword,
      meta: { needLogin: true }
    },
    {
      path: "/bindPhone",
      name: "bindPhone",
      component: BindPhone,
      meta: { needLogin: true }
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js